import React from "react";
import type { UseProductPreferences } from "../useProductPreferences.js";
import { ProductPreferenceButton } from "./ProductPreferenceButton.js";

const ProductPreferencesContext =
  React.createContext<UseProductPreferences | null>(null);

/**
 * Hands the list's preferences to its row buttons through context, so the row-action
 * components stay referentially stable across preference updates — a changing component
 * identity would remount every row's menu and close an open one.
 */
export const ProductPreferencesProvider = ProductPreferencesContext.Provider;

export function ProductPreferenceRowButton({
  productTypeId,
  product,
}: Pick<
  React.ComponentProps<typeof ProductPreferenceButton>,
  "productTypeId" | "product"
>) {
  const preferences = React.useContext(ProductPreferencesContext);
  if (preferences === null) {
    throw new Error(
      "ProductPreferenceRowButton must be rendered inside a ProductPreferencesProvider"
    );
  }
  return (
    <ProductPreferenceButton
      productTypeId={productTypeId}
      product={product}
      preferences={preferences}
    />
  );
}
